import { useState } from 'react';
import type { CampaignAnalytics, CampaignCounts } from '../../../api/client.ts';
import { CompareChart } from '../../dashboards/CompareChart.tsx';
import { SERIES_METRICS, usesChannel } from './analytics.ts';

/**
 * Historical performance (BB-104): one count of the campaign per day or local hour of the period, empty buckets
 * included. Counts sit on the send day of each fact (an open after midnight stays with its push); hours are when the
 * fact happened. Conversions are counted on the day their window opened.
 */
export function PerformanceChart({ data }: { data: CampaignAnalytics }) {
  const metrics = SERIES_METRICS.filter((m) => usesChannel(data, m.channel));
  const [chosen, setChosen] = useState<keyof CampaignCounts>('messagesSent');
  const metric = metrics.find((m) => m.key === chosen) ?? metrics[0]!;
  const unit = data.granularity === 'hour' ? 'hour' : 'day';
  return (
    <section aria-label="Performance over time" className="campaign-analytics__chart">
      <div className="toolbar">
        <label>
          Metric{' '}
          <select value={metric.key} onChange={(e) => setChosen(e.target.value as keyof CampaignCounts)}>
            {metrics.map((m) => (
              <option key={m.key} value={m.key}>
                {m.label}
              </option>
            ))}
          </select>
        </label>
      </div>
      {data.series.length > 0 && <CompareChart title={`${metric.label} by ${unit}`} days={data.series.map((s) => s.bucket)} series={[{ label: metric.label, values: data.series.map((s) => s.counts[metric.key]) }]} format="count" />}
      <p className="hint">
        {unit === 'hour' ? `Local hours in ${data.timezone}, when each fact happened.` : `Days in ${data.timezone}; opens and receipts count on the send day of their message.`} Conversions count on the {unit} their window opened.
      </p>
    </section>
  );
}
